import { schema as schemas } from 'normalizr'
import { CallApi } from '@signavio/kraken'
import queryString from 'qs'

import { Field, Task, RemoveCasePayloadType } from '../../../types'

import { USER } from '../users'
import { schema as taskSchema } from './task'

export const collection = 'cases'

export const schema = new schemas.Entity(collection, {
  tasks: [taskSchema],
  creator: USER.schema,
})

type FetchQueryT = {
  id: string
}

export const fetch =
  (callApi: CallApi, apiBase: string) =>
  ({ id }: FetchQueryT) =>
    callApi(`${apiBase}/cases/${id}`, schema)

type CreateBodyType = {
  name: string

  sourceWorkflowId?: string
  fields?: Field[]
}

export const create =
  (callApi: CallApi, apiBase: string) =>
  (_: unknown, { sourceWorkflowId, name, fields }: CreateBodyType) =>
    callApi(`${apiBase}/cases`, schema, {
      method: 'POST',
      body: {
        name,
        ...(sourceWorkflowId
          ? {
              triggerInstance: {
                sourceWorkflowId,

                ...(fields
                  ? {
                      data: {
                        formInstance: {
                          value: { fields },
                        },
                      },
                    }
                  : null),
              },
            }
          : null),
      },
    })

type UpdateQueryType = {
  id: string
}

export const update =
  (callApi: CallApi, apiBase: string) =>
  ({ id }: UpdateQueryType, body: Task) =>
    callApi(`${apiBase}/cases/${id}`, schema, { method: 'PUT', body })

type RemoveQueryT = {
  id: string
}

export const remove =
  (callApi: CallApi, apiBase: string) =>
  ({ id }: RemoveQueryT, { cascade }: RemoveCasePayloadType) => {
    const query = queryString.stringify(
      {
        cascade,
      },

      {
        addQueryPrefix: true,
      }
    )

    return callApi(`${apiBase}/cases/${id}${query}`, schema, {
      method: 'DELETE',
    })
  }
